/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CndnWorklist } from '../../models/cndn-worklist';
import { CriteriaCnDn } from '../../models/criteria-cn-dn';

export interface ApiBillingWorklistGetCndnWorklistPost$Params {
      body?: CriteriaCnDn
}

export function apiBillingWorklistGetCndnWorklistPost(http: HttpClient, rootUrl: string, params?: ApiBillingWorklistGetCndnWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CndnWorklist>>> {
  const rb = new RequestBuilder(rootUrl, apiBillingWorklistGetCndnWorklistPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CndnWorklist>>;
    })
  );
}

apiBillingWorklistGetCndnWorklistPost.PATH = '/api/BillingWorklist/GetCndnWorklist';
